'use strict';

export default function f() {
  'ngInject';

  return {
    getPaymentStatus(authStatus) {
      var status;

      switch (authStatus.toUpperCase()) {
      case 'AUTHORISED':
        status = 'successful';
        break;

      case 'PENDING':
        status = 'pending';
        break;

      default:
        status = 'failed';
        break;
      }

      return status;
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/payments.service.js